import { Injectable } from "@angular/core"
import { Apollo, QueryRef } from "apollo-angular"
import gql from "graphql-tag"
import { fragments as submissionQueriesFragments, Post as SubmissionQueriesPost } from 'modules/submissions/submission.queries'

interface MainQueryVariables {
  customerId: number
  writerId: number
  page: number
  perPage: number
  states: string[]
  order: string
}

export interface Post extends SubmissionQueriesPost {
  lastTransitionAt: Date
}

export interface Data {
  customer: {
    id: number
    posts: {
      totalCount: number
      entries: Post[]
    }
  }
}

const query = gql`
  query WriterCustomerPostsListQuery(
    $customerId: ID!,
    $writerId: Int,
    $page: Int,
    $perPage: Int,
    $states: [String],
    $order: String) {
    customer(id: $customerId) {
      id
      posts(
        writerId: $writerId,
        page: $page,
        perPage: $perPage,
        state: $states,
        order: $order
      ) {
        totalCount
        entries {
          lastTransitionAt
          ...SubmissionsPagePost
        }
      }
    }
  }
  ${submissionQueriesFragments.post}
`

@Injectable({providedIn: 'root'})
export class WriterCustomerPostsListQueries {
  constructor(private apollo: Apollo) {

  }

  mainQuery(variables: MainQueryVariables): QueryRef<Data> {
    return this.apollo.watchQuery<Data>({
      query,
      variables,
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only'
    })
  }
}
